var isAsciiDigit = function (char) {
    if (char.length !== 1) {
        return false;
    }
    var code = char.charCodeAt(0);
    return code >= 48 && code <= 57;
};
var isRfc3966VisualSeparator = function (char) {
    return char === " " || char === "-" || char === "." || char === "(" || char === ")";
};
/*
 * RFC 3966 allows visual separators in telephone numbers.
 * E.164 constrains global numbers to a maximum of 15 digits.
 */
export var normalizeSmsNumber = function (input) {
    var trimmed = String(input || "").trim();
    if (!trimmed) {
        return null;
    }
    var hasLeadingPlus = false;
    var digitCount = 0;
    var normalizedDigits = "";
    for (var index = 0; index < trimmed.length; index += 1) {
        var char = trimmed[index];
        if (index === 0 && char === "+") {
            hasLeadingPlus = true;
            continue;
        }
        if (isAsciiDigit(char)) {
            normalizedDigits += char;
            digitCount += 1;
            continue;
        }
        if (isRfc3966VisualSeparator(char)) {
            continue;
        }
        return null;
    }
    if (digitCount < 10 || digitCount > 15) {
        return null;
    }
    if (hasLeadingPlus && normalizedDigits[0] === "0") {
        return null;
    }
    return hasLeadingPlus ? "+".concat(normalizedDigits) : normalizedDigits;
};
export var isValidSmsNumber = function (input) {
    return normalizeSmsNumber(input) !== null;
};
